import React, { Fragment as _, useContext } from 'react';
import { Box } from 'theme-ui';

const AssessmentResults = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'yellow',
      }}
    >
      <h1>Assessment Results</h1>
    </Box>
  );
};

export default AssessmentResults;
